'use strict'

angular.module('basMarquee', [])

require('./basmarqueestate.factory')
require('./basmarqueesharedstate.factory')
require('./basmarquee.directive')
